import CryptoJs from "crypto-js";
import axios from "axios";
import store from "../redux/store";
import { LOGOUT } from "../redux/constants";
import moment from "moment";

let color_palette = [
  "#EFF8FF",
  "#DBEEFE",
  "#BFE2FE",
  "#92D1FE",
  "#5FB7FB",
  "#3A97F7",
  "#2F80ED",
  "#1C63D9",
  "#1D51B0",
  "#1D468B",
  "#172C54",
];

export function createColorPalette(length, color_arr) {
  let data = [];
  // while (length > color_palette.length) {
  //   data.push(...color_palette);
  //   length = length - color_palette.length;
  // }
  let counter = 1;
  while (length > color_arr.length) {
    if (counter % 2 === 0) {
      data.push(...color_arr.reverse());
      if (counter > 2) {
        length = length + 1 - color_arr.length;
      } else {
        length = length - color_arr.length;
      }
    } else {
      data.push(...color_arr.slice(0, color_arr.length - 1));
      color_arr = color_arr.reverse();
      length = length + 1 - color_arr.length;
    }
  }
  let addOn = 4;
  if (length >= 9) {
    addOn = 0;
  } else if (length >= 7) {
    addOn = 1;
  } else if (length >= 5) {
    addOn = 2;
  } else if (length >= 3) {
    addOn = 3;
  }
 
  let firstEle = color_arr.length - (length + addOn);
  let lastEle = firstEle + length;
  data = [...data, ...color_arr.slice(firstEle, lastEle)];
  return data;
}

export const to_do_type_options = [
  { value: "Document", label: "Job Level", name: "based_on" },
  { value: "Container", label: "Individual Asset Level", name: "based_on" },
];

export const defaultConfigs = [
  {
    title: "Allow Asset Entry",
    description: "Allow the Entry of Assets in this Task.",
    checked: false,
  },
  {
    title: "Allow Customers to Track This To Do",
    description:
      "If activated customers are able to see the progress of this to do for their bookings.",
    checked: false,
  },
  {
    title: "Validation",
    description: "Validate your API for this task.",
    checked: false,
  },
  {
    title: "Allow User Edit",
    description: "Allow Users to Edit Activity Performance.",
    checked: false,
  },
  {
    title: "Upload File",
    description: "Allow the Upload of Files.",
    checked: false,
  },
  {
    title: "Extension",
    description: "Allow the Users to Request for Extension.",
    checked: false,
  },
];

export const reminderTimeDropdownOptions = [
  {
    label: "1h (before End Time)",
    value: 1,
  },
  {
    label: "6h (before End Time)",
    value: 6,
  },
  {
    label: "12h (before End Time)",
    value: 12,
  },
  {
    label: "24h (before End Time)",
    value: 24,
  },
  {
    label: "48h (before End Time)",
    value: 48,
  },
  {
    label: "72h (before End Time)",
    value: 72,
  },
];

export function checkBlankSpace(value) {
  return /^[^\s]+(?:$|.*[^\s]+$)/.test(value) ? false : true;
}

export function checkLength(value) {
  return value.length > 1 && value.length <= 100 ? true : false;
}

export function checkNumber(value) {
  return /^[0-9]{6,12}$/.test(value) ? false : true;
}

export function checkMinLength(value) {
  return value <= 6 ? true : false;
}

export function getDateTimeWithFormat(date) {
  return moment(date).format("DD MMM, yyyy - hh:mm a");
}

export function getDateWithFormat(date) {
  return moment(date).format("DD MMM, yyyy");
}

export function getDateWithFormatUTC(date) {
  return moment.utc(date).format("DD MMM, yyyy");
}

export function encryptData(data) {
  let result = data;

  if (process.env.REACT_APP_ENCRYPTION === "true") {
    result = {
      key: CryptoJs.AES.encrypt(
        JSON.stringify(data),
        process.env.REACT_APP_ENCRYPTION_SECRET_KEY
      ).toString(),
    };
  }
  return result;
}

export function decryptData(data) {
  let result = data;
  // if(process.env.REACT_APP_ENVIRONMENT === "production"){
  result = JSON.parse(
    CryptoJs.AES.decrypt(
      data,
      process.env.REACT_APP_ENCRYPTION_SECRET_KEY
    ).toString(CryptoJs.enc.Utf8)
  );
  // }
  return result;
}

export const sanitizeInput = (value) => {
  return value.replace(/<\/?[^>]+(>|$)/g, "");
};

var config = {
  headers: {
    "Content-Type": "application/json",
    encryption: "true",
  },
};

const setAuthorizationToken = (axios, token) => {
  const state = store.getState();
  axios.defaults.headers.common.Authorization = `Bearer ${state.auth.token}`;
};

export class ApiCall {
  static post(url, params, token = null) {
    setAuthorizationToken(axios, token);
    const payload = encryptData(params);
    // console.log('payload --', params)
    return new Promise((fulfill, reject) => {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}` + url,
          JSON.stringify(payload),
          config
        )
        .then(function (response) {
          fulfill(response.data);
        })
        .catch(function (error) {
          if (error && error.response) {
            if (error.response.status === 401) {
              store.dispatch({ type: LOGOUT });
            }
            reject(error.response?.data);
          } else {
            reject(error);
          }
        });
    });
  }

  static put(url, params, token = null) {
    setAuthorizationToken(axios, token);
    const payload = encryptData(params);
    //console.log('payload ---', params)
    return new Promise(function (fulfill, reject) {
      axios
        .put(
          `${process.env.REACT_APP_API_URL}` + url,
          JSON.stringify(payload),
          config
        )
        .then(function (response) {
          fulfill(response.data);
        })
        .catch(function (error) {
          if (error && error.response) {
            if (error.response.status === 401) {
              store.dispatch({ type: LOGOUT });
            }
            reject(error.response?.data);
          } else {
            reject(error);
          }
        });
    });
  }

  static get(url, token = null) {
    setAuthorizationToken(axios, token);
    return new Promise(function (fulfill, reject) {
      axios
        .get(`${process.env.REACT_APP_API_URL}` + url, config)
        .then(function (response) {
          fulfill(response.data);
        })
        .catch(function (error) {
          if (error && error.response) {
            if (error.response.status === 401) {
              store.dispatch({ type: LOGOUT });
            }
            reject(error.response?.data);
          } else {
            reject(error);
          }
        });
    });
  }

  static patch(url, params, token = null) {
    setAuthorizationToken(axios, token);
    const payload = encryptData(params);
    return new Promise(function (fulfill, reject) {
      axios
        .patch(
          `${process.env.REACT_APP_API_URL}` + url,
          JSON.stringify(payload),
          config
        )
        .then(function (response) {
          fulfill(response.data);
        })
        .catch(function (error) {
          if (error && error.response) {
            if (error.response.status === 401) {
              store.dispatch({ type: LOGOUT });
            }
            reject(error.response?.data);
          } else {
            reject(error);
          }
        });
    });
  }

  static delete(url, token = null) {
    setAuthorizationToken(axios, token);
    return new Promise(function (fulfill, reject) {
      axios
        .delete(`${process.env.REACT_APP_API_URL}` + url, config)
        .then(function (response) {
          fulfill(response.data);
        })
        .catch(function (error) {
          if (error && error.response) {
            if (error.response.status === 401) {
              store.dispatch({ type: LOGOUT });
            }
            reject(error.response?.data);
          } else {
            reject(error);
          }
        });
    });
  }

  /*************** Form-Data post with file Method ***********/
  static postFormData(url, body, token = null) {
    setAuthorizationToken(axios, token);
    return new Promise((fulfill, reject) => {
      axios
        .post(`${process.env.REACT_APP_API_URL}` + url, body, {
          headers: {
            "Content-Type": "multipart/form-data",
            encryption: "true",
          },
        })

        .then((response) => {
          fulfill(response.data);
        })
        .catch((error) => {
          if (error && error.response) {
            if (error.response.status === 401) {
              store.dispatch({ type: LOGOUT });
            }
            reject(error.response?.data);
          } else {
            reject(error);
          }
        });
    });
  }

  /*************** Form-Data update with file Method ***********/
  static patchFormData(url, body, token = null) {
    setAuthorizationToken(axios, token);
    return new Promise((fulfill, reject) => {
      axios
        .patch(`${process.env.REACT_APP_API_URL}` + url, body, {
          headers: {
            "Content-Type": "multipart/form-data",
            encryption: "true",
          },
        })
        .then((response) => {
          fulfill(response.data);
        })
        .catch((error) => {
          if (error && error.response) {
            if (error.response.status === 401) {
              store.dispatch({ type: LOGOUT });
            }
            reject(error.response?.data);
          } else {
            reject(error);
          }
        });
    });
  }
}

export const downloadExcel = (response, type) => {
  // Create a URL for the file and trigger the download
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${type}.xlsx`); // Set the file name
  document.body.appendChild(link);
  link.click();
  link.remove();
}

export const default_color_palettes = {
  "50": "#ebf3fd",
  "100": "#c5dcfa",
  "200": "#a0c5f7",
  "300": "#7aaef3",
  "400": "#5597f0",
  "500": "#2f80ed",
  "600": "#136be0",
  "700": "#1059ba",
  "800": "#0d4795",
  "900": "#0a356f",
  "950": "#202E56"
}


export const validateDateWithWorkingHoursTimeZone = (timezone, work_hours, current_todo_end_time, link_todo_end_time) => {
  // return new Promise((resolve, reject) => {
    try {
      const offsetMatch = timezone.match(/\(UTC([+-]\d{2}:\d{2})\)/);
      const offset = offsetMatch ? offsetMatch[1] : null;
      let nextDate = null;
      let working_hours = JSON.parse(work_hours.working_hours);

      // if (work_hours.is_prepone) {

      //   let date = moment(new Date(current_todo_end_time))
      //   .utcOffset(offset)
      //   .format('YYYY-MM-DD HH:mm:ss');
        
      //   const day = moment(date).format('dddd').toLowerCase();
      //   const findWorkDay = getNextActiveDay(working_hours, day);
      //   if (!findWorkDay.work_day) {
      //     return null;
      //   }

      //   if (findWorkDay.days_count > 0) {
      //     date = moment(date).add(findWorkDay.days_count, 'days');

      //     nextDate = moment(new Date(date))
      //       .set({
      //         hour: parseInt(findWorkDay.work_day.start_time.split(':')[0], 10),
      //         minute: parseInt(
      //           findWorkDay.work_day.start_time.split(':')[1],
      //           10
      //         ),
      //         second: 0,
      //         millisecond: 0,
      //       })
      //       .format('YYYY-MM-DD HH:mm:ss');
      //   } else {
      //     nextDate = moment(new Date(date))
      //       .set({
      //         hour: parseInt(findWorkDay.work_day.end_time.split(':')[0], 10),
      //         minute: parseInt(findWorkDay.work_day.end_time.split(':')[1], 10),
      //         second: 0,
      //         millisecond: 0,
      //       })
      //       .format('YYYY-MM-DD HH:mm:ss');
      //   }

      //   nextDate = moment(new Date(nextDate))
      //     .utcOffset(offset)
      //     .format('YYYY-MM-DD HH:mm:ss');

      //   return nextDate;


      // }

      let date = moment(new Date(link_todo_end_time))
        .utcOffset(offset)
        .format('YYYY-MM-DD HH:mm:ss');
      const day = moment(date).format('dddd').toLowerCase();
      const findWorkDay = getNextActiveDay(working_hours, day);
      if (!findWorkDay.work_day) {
        return null;
      }

      if (findWorkDay.days_count > 0) {

        date = moment(date).add(findWorkDay.days_count, 'day');

        nextDate = moment(new Date(date))
          .set({
            hour: parseInt(findWorkDay.work_day.start_time.split(':')[0], 10),
            minute: parseInt(findWorkDay.work_day.start_time.split(':')[1], 10),
            second: 0,
            millisecond: 0,
          })
          .format('YYYY-MM-DD HH:mm:ss');

        nextDate = moment(new Date(nextDate))
          .utcOffset(offset)
          .format('YYYY-MM-DD HH:mm:ss');

        return nextDate;
      }

      const onlyTime = moment(date, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');

      const isWithinRange = moment(onlyTime, 'HH:mm').isBetween(
        moment(findWorkDay.work_day.start_time, 'HH:mm'),
        moment(findWorkDay.work_day.end_time, 'HH:mm'),
        undefined,
        '[]'
      );

      if (isWithinRange) {
        nextDate = moment(new Date(date))
          .utcOffset(offset)
          .format('YYYY-MM-DD HH:mm:ss');

        return nextDate;
      }

      const isBefore = moment(onlyTime, 'HH:mm').isBefore(
        moment(findWorkDay.work_day.start_time, 'HH:mm')
      );

      if (isBefore) {
        nextDate = moment(new Date(date))
          .set({
            hour: parseInt(findWorkDay.work_day.start_time.split(':')[0], 10),
            minute: parseInt(findWorkDay.work_day.start_time.split(':')[1], 10),
            second: 0,
            millisecond: 0,
          })
          .format('YYYY-MM-DD HH:mm:ss');

        nextDate = moment(new Date(nextDate))
          .utcOffset(offset)
          .format('YYYY-MM-DD HH:mm:ss');

        return nextDate;
      }

      const isAfter = moment(onlyTime, 'HH:mm').isAfter(
        moment(findWorkDay.work_day.start_time, 'HH:mm')
      );

      if (isAfter) {

        if(work_hours.is_prepone){
          nextDate = moment(new Date(date))
            .set({
              hour: parseInt(findWorkDay.work_day.end_time.split(':')[0], 10),
              minute: parseInt(findWorkDay.work_day.end_time.split(':')[1], 10),
              second: 0,
              millisecond: 0,
            })
            .format('YYYY-MM-DD HH:mm:ss');

          nextDate = moment(new Date(nextDate))
            .utcOffset(offset)
            .format('YYYY-MM-DD HH:mm:ss');

          return nextDate;
        }else{
          date = moment(date).add(1, "day");
          const day = moment(date).format('dddd').toLowerCase();
          const findWorkDay = getNextActiveDay(working_hours, day);
          if (!findWorkDay.work_day) {
            return null;
          }

          if (findWorkDay.days_count > 0) {
            
            date = moment(date).add(findWorkDay.days_count, 'day');

            nextDate = moment(new Date(date))
              .set({
                hour: parseInt(findWorkDay.work_day.start_time.split(':')[0], 10),
                minute: parseInt(findWorkDay.work_day.start_time.split(':')[1], 10),
                second: 0,
                millisecond: 0,
              })
              .format('YYYY-MM-DD HH:mm:ss');

            nextDate = moment(new Date(nextDate))
              .utcOffset(offset)
              .format('YYYY-MM-DD HH:mm:ss');

            return nextDate;

          }

          nextDate = moment(new Date(date))
            .set({
              hour: parseInt(findWorkDay.work_day.start_time.split(':')[0], 10),
              minute: parseInt(findWorkDay.work_day.start_time.split(':')[1], 10),
              second: 0,
              millisecond: 0,
            })
            .format('YYYY-MM-DD HH:mm:ss');

          nextDate = moment(new Date(nextDate))
            .utcOffset(offset)
            .format('YYYY-MM-DD HH:mm:ss');
          
          return nextDate
        }
      }

      return nextDate
    } catch (error) {
      return error;
    }
  // });
};

const daysOfWeek = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

const getNextActiveDay = (working_hours, day) => {
  const currentDayIndex = daysOfWeek.indexOf(day.toLowerCase());

  for (let i = currentDayIndex; i < daysOfWeek.length; i++) {
    const daySchedule = working_hours[i];
    if (daySchedule.is_active) {
      return {
        work_day: daySchedule,
        days_count: i - currentDayIndex,
      };
    }
  }

  for (let i = 0; i < currentDayIndex; i++) {
    const daySchedule = working_hours[i];
    if (daySchedule.is_active) {
      return {
        work_day: daySchedule,
        days_count: i + (7 - currentDayIndex),
      };
    }
  }

  return { work_day: null, days_count: 0 };
};


export const allowUploadExtension = [".pdf",".doc",".docx",".xls",".xlsx",".jpeg",".jpg",".png",".bmp",".txt"];

export const isFloat = (num) => {
  return Number.isFinite(num) && !Number.isInteger(num);
}

export const isDate = (value) => {
  if (value instanceof Date && !isNaN(value.getTime())) {
    return true;
  }
  if (typeof value === "string") {
    const strictDatePattern = /^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}:\d{2}(\.\d{3})?Z)?$/;
    const regexTest = strictDatePattern.test(value);
    if (regexTest) {
      const parsedDate = new Date(value);
      if (!isNaN(parsedDate.getTime())) {
        return true;
      }
    }
  }
  return false;
};